import 'bootstrap/dist/css/bootstrap.css';
import './assets/css/index.css'
import './assets/dmgAssets/css/style.css'
import React from 'react';
import ReactDOM from 'react-dom';
import { Route, BrowserRouter as Router, Switch, Redirect } from 'react-router-dom';
import unregister from './registerServiceWorker';
import { MsalProvider, MsalAuthenticationTemplate, MsalUnauthenticatedTemplate } from "@azure/msal-react";
import { InteractionType, EventType } from "@azure/msal-browser";
import { pca, loginRequest, getDMGUser, isViableDMGUser, isDMGUser } from './authProvider';
import FileEx from './pages/FileEx';
import CreateArea from './pages/CreateArea';
import CreateUser from './pages/CreateUser';
import FileExLogo from './components/FileExLogo';
import ReactSpinner from 'react-bootstrap-spinner';
import { checkAccess } from './fetchData';
import toast, { Toaster } from 'react-hot-toast';
import AdHoc from './pages/AdHoc';

const rootElement = document.getElementById('root');

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            width: window.innerWidth,
            username: '',
            userAllowed: false,
            accessChecked: false
        }

        this.errorComponent = this.errorComponent.bind(this);
        this.loadingComponent = this.loadingComponent.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.updateWidth);
        pca.addEventCallback(message => {
            switch (message.eventType) {
                case EventType.HANDLE_REDIRECT_END:
                    if (isDMGUser()) {
                        checkAccess().then((res) => {
                            this.setState({
                                username: getDMGUser(), 
                                userAllowed: res,
                                accessChecked: true
                            });
                        }).catch(() => {
                            toast.error("Error authorizing user.");
                        })
                    }
                    else {
                        this.setState({
                            username: getDMGUser(),
                            userAllowed: true,
                            accessChecked: true
                        });
                    }
            }
        });
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWidth);
    }

    updateWidth = () => {
        this.setState({
            width: window.innerWidth
        })
    }

    errorComponent = ({ error }) => {
        return (
            <div className="content" style={{ textAlign: "center" }}>
                <div style={{ marginBottom: 10, width: this.state.width > 800 ? "75%" : "100%", display: "inline-block" }}>
                    <FileExLogo />
                    <div style={{ flex: '0 0 auto' }}>
                        An error occurred: {error ? error.errorCode : "unknown error"}
                    </div>
                </div>
            </div>
        )
    }

    loadingComponent = () => {
        return (
            <div className="content" style={{ textAlign: "center" }}>
                <div style={{ marginBottom: 10, width: this.state.width > 800 ? "75%" : "100%", display: "inline-block" }}>
                    <FileExLogo />
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div style={{ flex: '1' }}>
                            <ReactSpinner type="border" color="black" size="3" />
                        </div>
                        <div style={{ flex: '0 0 auto' }}>
                            Authentication in progress...
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    downloadManual = (lang) => {
        var getUrl = window.location;
        var baseUrl = getUrl.protocol + "//" + getUrl.host + "/" + getUrl.pathname.split('/')[1];
        var guideTab = window.open(baseUrl + "api/download/manual/" + lang + "/FileEx Manual", '_blank');
        guideTab.focus();
    }

    render() {
        const authRequest = {
            ...loginRequest
        };
        return (
            <Router>
                <MsalProvider instance={pca}>
                        <div className="content" style={{ textAlign: "center" }}>
                            <Toaster />
                            <div style={{ marginBottom: 10, width: this.state.width > 800 ? "75%" : "100%", display: "inline-block" }}>

                            <Switch>
                                <Route exact path='/'>
                                    <MsalAuthenticationTemplate
                                        interactionType={InteractionType.Redirect}
                                        authenticationRequest={authRequest}
                                        errorComponent={this.errorComponent}
                                        loadingComponent={this.loadingComponent}>
                                        <FileEx {...this.props} appWidth={this.state.width} accessChecked={this.state.accessChecked} userAllowed={this.state.userAllowed} />
                                    </MsalAuthenticationTemplate>
                                </Route>

                                <Route exact path='/createArea'>
                                    <MsalAuthenticationTemplate
                                        interactionType={InteractionType.Redirect}
                                        authenticationRequest={authRequest}
                                        errorComponent={this.errorComponent}
                                        loadingComponent={this.loadingComponent}>
                                        <CreateArea />
                                    </MsalAuthenticationTemplate>
                                </Route>

                                <Route exact path='/createUser'>
                                    <MsalAuthenticationTemplate
                                        interactionType={InteractionType.Redirect}
                                        authenticationRequest={authRequest}
                                        errorComponent={this.errorComponent}
                                        loadingComponent={this.loadingComponent}>
                                        <CreateUser />
                                    </MsalAuthenticationTemplate>
                                </Route>
                                <Route exact path='/adhoc'>
                                    <AdHoc {...this.props} appWidth={this.state.width} />
                                </Route>
                                <Route render={() => <Redirect to="/" />} />
                            </Switch>
                            </div>
                        </div>
                </MsalProvider>
            </Router>
        )
    }
}

ReactDOM.render(
    <App />,
    rootElement);

unregister();

